import Image from "next/image";
import styles from "./prestorming.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
const Chennai = dynamic(() => import("../prestromong-chennai/pre-chennai"));
const Delhi = dynamic(() => import("../prestromong-chennai/pre-delhi"));
const Bengaluru = dynamic(() => import("../prestromong-chennai/pre-bengaluru"));
const Trivandrum = dynamic(() => import("../prestromong-chennai/pre-trivandrum"));
const Trichy = dynamic(() => import("../prestromong-chennai/pre-trichy"));
const Salem = dynamic(() => import("../prestromong-chennai/pre-salem"));
const Coimbatore = dynamic(() => import("../prestromong-chennai/pre-coimbatore"));
const Madurai = dynamic(() => import("../prestromong-chennai/pre-madurai"));
const Hyderabad = dynamic(() => import("../prestromong-chennai/pre-hyderabad"));
const Content = dynamic(() => import("../prestromong-chennai/pre-content"));
const Online = dynamic(() => import("../prestromong-chennai/pre-online"));
const BranchAddress = dynamic(()=>import("../../components/branch-address"));
import Prelims_Form from "./prestorming-form";
import Prelimsmain from "../../assets/images/upsc-prelims/prestorming-web-banner-batch-VI.jpg";
import Head from "next/head";


const Prelims = () => { 

  return (
    <>
              <Head>
                <meta charset="UTF-8" />
                 <link rel="icon" href="./logo.png" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>Upsc Prelims Test Series - Shankar IAS Academy</title>
                <meta name="title" content="Upsc Prelims Test Series - Shankar IAS Academy" />
                <meta name="description" content="ShankarIas Acadamy " />
                <link rel="canonical" href="https://www.shankariasacademy.com/upsc-prelims-test-series/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Upsc Prelims Test Series - Shankar IAS Academy" />
                <meta property="og:description" content="ShankarIas Acadamy " />
                <meta property="og:url" content="https://www.shankariasacademy.com/upsc-prelims-test-series/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
              </Head>  
    <Navbar title="upsc" />

<div className={`${styles.tabsection}`}>
<div className="container">
        <div className="row">
          <div className="col pt-3 pt-md-5">
            <h1 className={`${styles.pagemaintitle}`}>
              UPSC Prelims Test Series 2024
            </h1>
          </div>
        </div>

        <div className="container">
        <div className="row">
          <div className="col">
            <div
              className={`${styles.tabscrollclass} nav nav-pills mb-3 align-items-baseline`}
            >
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4 active"
                data-bs-toggle="pill"
                data-bs-target="#centre-1"
                type="button"
                role="tab"
                aria-controls="centre-1"
                aria-selected="true"
              >
                Chennai
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-2"
                type="button"
                role="tab"
                aria-controls="centre-2"
                aria-selected="false"
              >
                Delhi
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-3"
                type="button"
                role="tab"
                aria-controls="centre-3"
                aria-selected="false"
              >
                Bengaluru
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-4"
                type="button"
                role="tab"
                aria-controls="centre-4"
                aria-selected="false"
              >
                Trivandrum
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-5"
                type="button"
                role="tab"
                aria-controls="centre-5"
                aria-selected="false"
              >
                Hyderabad
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-6"
                type="button"
                role="tab"
                aria-controls="centre-6"
                aria-selected="false"
              >
                Trichy
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-7"
                type="button"
                role="tab"
                aria-controls="centre-7"
                aria-selected="false"
              >
                Salem
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-8"
                type="button"
                role="tab"
                aria-controls="centre-8"
                aria-selected="false"
              >
                Coimbatore
              </button>
              <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-9"
                type="button"
                role="tab"
                aria-controls="centre-9"
                aria-selected="false"
              >
                Madurai
              </button>

              <a href="#onlineclass"> <button
                id={styles.tablinks}
                className="nav-link py-2 px-0 me-4"
                data-bs-toggle="pill"
                data-bs-target="#centre-10"
                type="button"
                role="tab"
                aria-controls="centre-10"
                aria-selected="false"
              >
               Online 
              </button></a>
            
            </div>
          </div>
        </div>
      </div>
        
      </div>
</div>
      
      <div className={`${styles.imagee} container`}>
      <div className="row">
          <div className="col pt-2 mb-3">
            <Image
              src={Prelimsmain}
              alt="prestroming banner"
              title="UPSC Prelims Test Series 2023"
              className="img-fluid w-100"
            />
          </div>
        </div>
      </div>

      <div className="container">
      <div className="row">
          <div className="col pt-2" id="scheduledetails">
            <h2 className={`${styles.sectiontitle} mb-0`}>
              Prelims Test (Prestorming) Centres, Schedule & Enrolment
            </h2>
          </div>
        </div>
      </div>

      <Prelims_Form />

      <div className="tab-content">

        <div className="tab-pane active" id="centre-1">
          <Chennai />
        </div>

        <div className="tab-pane" id="centre-2">
          <Delhi />
        </div>

        <div className="tab-pane" id="centre-3">
           <Bengaluru />
        </div>

        <div className="tab-pane" id="centre-4">
          <Trivandrum />  
        </div>

        <div className="tab-pane" id="centre-5">
          <Hyderabad />  
        </div>
        
        <div className="tab-pane" id="centre-6">
          <Trichy />
        </div>

        <div className="tab-pane" id="centre-7">
          <Salem /> 
        </div>

        <div className="tab-pane" id="centre-8">
          <Coimbatore />
        </div>

        <div className="tab-pane" id="centre-9">
          <Madurai /> 
        </div>

        <div className="tab-pane" id="centre-10">
          <Online /> 
        </div>

      </div>
    
      <Content /> 
      <BranchAddress />  
      <Interest />
      <Footer />
    </>
  );
};
export default Prelims;
